import { Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function TelegramActivationFeedback({ error, actionKey }: { error: string; actionKey?: string }) {
  const { t } = useTranslation();
  return error ? <Alert severity="error">{error}{actionKey && <> {t(actionKey)}</>}</Alert> : null;
}
